import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

export const onPersonCardOrgChartCardClicked = (
	props: commonAttributesType,
): AnalyticsEventPayload => {
	const { source } = props;
	return {
		action: 'clicked',
		actionSubject: 'personCardOrgChartCard',
		source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
		},
	};
};
